(function ($) {
  "use strict";
  jQuery(document).ready(function() {
    // menu toggler js
    $("button.navbar-toggle").on('click', function() {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $(".close-box").on('click', function() {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });
    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });
    // body background color js
    $(".mm-fullscreen-bg").on('click',function() {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    $('.full-view, .zoom').on('click', function() {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type:'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        }
      }).magnificPopup('open');
    });
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
    $('.item-data').on("click", function() {
      $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
      $(this).closest('form-wrap').addClass('active-variant');
      var it_img = $(this).attr('dataimg');
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
      var price = $(this).attr('dataprice');
      var compareprice = $(this).attr('datacompare');
      var stocks = $(this).attr('dataavailable');
      $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
        $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      }else{
        $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
      }
    });
    var swiper = new Swiper('.drawer-slider', {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row' | 'column',
      },
      spaceBetween: 30,
      navigation: {
        nextEl: '.arrow-next-drawer',
        prevEl: '.arrow-prev-drawer',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      speed: 1000,
    });
  });
})(jQuery);

(function () {
  if (window.__judgemeMouseDragInitialized) return;
  window.__judgemeMouseDragInitialized = true;

  var BLOCK_ID = 'Ac2M3VzQ3cVZWcEVNb__judge_me_reviews_cards_carousel_jTFd3c';

  function findBlock(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-jdgm-block-id="' + BLOCK_ID + '"]');
  }

  function getTransformX(element) {
    var transform = window.getComputedStyle(element).transform;
    if (!transform || transform === 'none') return 0;
    try {
      return new DOMMatrixReadOnly(transform).m41;
    } catch (error) {
      var match = transform.match(/matrix\([^,]+,[^,]+,[^,]+,[^,]+,([^,]+),[^,]+\)/);
      return match ? parseFloat(match[1]) : 0;
    }
  }

  function initJudgeMeMouseDrag() {
    var dragState = null;
    var suppressClick = false;

    function finishDrag(event) {
      if (!dragState) return;
      var state = dragState;
      dragState = null;

      if (state.cardsWrapper) {
        state.cardsWrapper.classList.remove('is-dragging');
      }
      if (state.videosContainer) {
        state.videosContainer.classList.remove('is-dragging');
        state.videosContainer.style.transition = state.originalTransition;
      }

      if (!state.horizontal) return;

      var dx = event.clientX - state.startX;
      var threshold = 50;
      var navigated = false;

      if (dx <= -threshold && typeof window.jdgmNextCard === 'function') {
        window.jdgmNextCard(BLOCK_ID);
        navigated = true;
      } else if (dx >= threshold && typeof window.jdgmPreviousCard === 'function') {
        window.jdgmPreviousCard(BLOCK_ID);
        navigated = true;
      }

      if (!navigated && state.videosContainer) {
        state.videosContainer.style.transform = 'translateX(' + state.startTransformX + 'px)';
      }

      suppressClick = true;
      setTimeout(function () {
        suppressClick = false;
      }, 0);
    }

    function cancelDrag() {
      if (!dragState) return;
      var state = dragState;
      dragState = null;

      if (state.cardsWrapper) {
        state.cardsWrapper.classList.remove('is-dragging');
      }
      if (state.videosContainer) {
        state.videosContainer.classList.remove('is-dragging');
        state.videosContainer.style.transition = state.originalTransition;
        state.videosContainer.style.transform = 'translateX(' + state.startTransformX + 'px)';
      }
    }

    document.addEventListener('dragstart', function (event) {
      if (findBlock(event.target)) {
        event.preventDefault();
      }
    }, true);

    document.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;

      var block = findBlock(event.target);
      if (!block) return;

      if (event.target.closest('.jdgm-arrow, a, button')) return;

      var content = block.querySelector('.jdgm-content');
      if (!content) return;

      var cardsWrapper = block.querySelector('.jdgm-cards-wrapper');
      var videosContainer = block.querySelector('.jdgm-videos-container');

      if (event.target.tagName === 'IMG') {
        event.preventDefault();
      }

      dragState = {
        block: block,
        content: content,
        cardsWrapper: cardsWrapper,
        videosContainer: videosContainer,
        startX: event.clientX,
        startY: event.clientY,
        startTransformX: videosContainer ? getTransformX(videosContainer) : 0,
        originalTransition: videosContainer ? videosContainer.style.transition : '',
        moved: false,
        horizontal: false
      };

      if (videosContainer) {
        videosContainer.style.transition = 'none';
        videosContainer.classList.add('is-dragging');
      }
      if (cardsWrapper) {
        cardsWrapper.classList.add('is-dragging');
      }
    }, true);

    document.addEventListener('mousemove', function (event) {
      if (!dragState) return;

      var dx = event.clientX - dragState.startX;
      var dy = event.clientY - dragState.startY;

      if (!dragState.moved && Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      dragState.moved = true;

      if (Math.abs(dx) <= Math.abs(dy)) return;

      if (!dragState.horizontal) {
        dragState.horizontal = true;
      }

      event.preventDefault();
      event.stopPropagation();

      if (dragState.videosContainer) {
        dragState.videosContainer.style.transform = 'translateX(' + (dragState.startTransformX + dx) + 'px)';
      }
    });

    window.addEventListener('mouseup', finishDrag, true);
    window.addEventListener('blur', cancelDrag, true);

    document.addEventListener('click', function (event) {
      if (!suppressClick) return;
      if (!findBlock(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJudgeMeMouseDrag);
  } else {
    initJudgeMeMouseDrag();
  }
})();
